module.exports = __webpack_public_path__ + "static/media/food-sci.8a131f41.jpg";